/** Motivos de descarte mostrados en el modal de publicaciones descartadas */
export interface DiscardedPublicationReason {
  commercialName: string;
  description: string;
}

export const DISCARDED_PUBLICATION_REASONS: DiscardedPublicationReason[] = [
  {
    commercialName: 'Publicación con observaciones críticas',
    description:
      'Se excluye por ser un vehículo chocado, de remate, taxi o con problemas legales que alteran su valor.',
  },
  {
    commercialName: 'Publicación de zona extrema',
    description:
      'Los precios en zonas extremas (Regiones XV, XI, XII) varían mucho y no representan el promedio nacional.',
  },
  {
    commercialName: 'Publicación expirada',
    description:
      'El vehículo lleva demasiado tiempo publicado y su precio podría estar desactualizado.',
  },
  {
    commercialName: 'Publicación duplicada',
    description:
      'Detectamos este vehículo en varios sitios. Solo contamos uno para no distorsionar el precio.',
  },
  {
    commercialName: 'Precio fuera de rango de mercado',
    description:
      'El valor es demasiado alto o bajo comparado con modelos similares, por lo que se considera un error.',
  },
  {
    commercialName: 'Publicación de Leasing',
    description:
      'No incluimos camionetas rojas porque suelen venir de faenas mineras, con un desgaste mayor al uso particular.',
  },
];
